import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable({
    providedIn: 'root'
  })
export class TableSortService {

    constructor() { }
    
    getSortedData(sort:any,refTable:any){
    if (sort.key && sort.value) {
      refTable = refTable.sort((a:any, b:any) =>
      sort.value === 'ascend'
          ? a[sort.key!] > b[sort.key!]
            ? 1
            : -1
          : b[sort.key!] > a[sort.key!]
            ? 1
            : -1
      );

      return refTable
    } else {
        return refTable
    }
        
    }
}
